'use client';

import { createContext } from 'react';

import type { TooltipRootContextInterface } from '../types/tooltip-root.types';

export const TooltipRootContext = createContext({} as TooltipRootContextInterface);

TooltipRootContext.displayName = 'Tooltip.Root.Context';
